import axios from "axios";

//IMPORT API ROUTE URL
import { GET_SKILLS_BY_SEARCH_TEXT_ROUTE } from "./apiRoutes";

const getSkillsBySearchText = (search_text, resourceSlug) => {
  var postData = new FormData();

  postData.append("search_text", search_text);
  postData.append("resource_slug", resourceSlug);

  return axios
    .post(GET_SKILLS_BY_SEARCH_TEXT_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      console.log(response, "--------------------");

      return response;
    })
    .catch(function (error) {
      console.log(error, "=====================");
      return false;
    });
};

export default getSkillsBySearchText;
